/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'double-arrow': {
    width: 17,
    height: 8,
    viewBox: '0 0 17 8',
    data:
      '<path pid="0" d="M.872 4.415L4.12 7.473l7.01-6.377M7.97 6.411l1.15 1.062 7.009-6.377" _fill="none" fill-rule="evenodd" _stroke="#FFF"/>'
  }
})
